import { useEffect } from 'react';
export default function useScrollReveal() {
  useEffect(() => {
    if (!window.IntersectionObserver || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;
    const elements = [...document.querySelectorAll('.bz-reveal')];
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .08 });
    elements.forEach(element => {
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('bz-reveal-ready'); observer.observe(element);
    });
    return () => { observer.disconnect(); elements.forEach(element => element.classList.remove('bz-reveal-ready','is-visible')); };
  }, []);
}
